var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(["\n        margin-bottom: 0;   \n        margin-left: 2rem;   \n        &:first-of-type {\n            margin-left: 0; \n    }    \n    "], ["\n        margin-bottom: 0;   \n        margin-left: 2rem;   \n        &:first-of-type {\n            margin-left: 0; \n    }    \n    "]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import styled from "styled-components";
import { Typography, Grid, media } from "../../index";

// TYPE STYLES
export var Caption = function Caption(_ref) {
  var children = _ref.children;
  return React.createElement(
    Typography,
    { size: 1, uppercase: true, bold: true, gutterBottom: true },
    children
  );
};

var Link = function Link(_ref2) {
  var children = _ref2.children,
      restProps = _objectWithoutProperties(_ref2, ["children"]);

  return React.createElement(
    "div",
    null,
    React.createElement(
      LinkStyled,
      _extends({
        $as: "a",
        gutterBottom: true,
        size: 1,
        display: "inline-block"
      }, restProps),
      children
    )
  );
};

export { Link };
var LinkStyled = styled(Typography).withConfig({
  displayName: "atoms__LinkStyled",
  componentId: "sc-1i2egv4-0"
})(["&:hover{text-decoration:underline;}"]);

// STYLED
export var Box = styled.div.withConfig({
  displayName: "atoms__Box",
  componentId: "sc-1i2egv4-1"
})(["width:100%;margin-bottom:2rem;"]);

export var AppContainer = styled.div.withConfig({
  displayName: "atoms__AppContainer",
  componentId: "sc-1i2egv4-2"
})(["width:100%;display:flex;flex-direction:row;.app-wrapper:first-of-type{margin-right:1rem;}@media screen and (min-width:48em) and (max-width:73em){flex-direction:column;display:block;.app-wrapper:first-of-type{margin-bottom:1rem;margin-right:0;}}"]);

var AppWrapper = styled.a.withConfig({
  displayName: "atoms__AppWrapper",
  componentId: "sc-1i2egv4-3"
})(["flex:1;height:3rem;max-width:330px;border-radius:4px;display:flex;align-items:center;background-color:black;color:", ";padding-left:0.75rem;cursor:pointer;&:hover{background-color:", ";}"], function (props) {
  return props.theme.colors.coreWhite;
}, function (props) {
  return props.theme.colors.darkGrey;
});

var Icon = styled.span.withConfig({
  displayName: "atoms__Icon",
  componentId: "sc-1i2egv4-4"
})(["font-size:1.75rem;line-height:1rem;margin-right:0.75rem;"]);

var AppBox = function AppBox(_ref3) {
  var icon = _ref3.icon,
      textTop = _ref3.textTop,
      textBottom = _ref3.textBottom,
      href = _ref3.href,
      restProps = _objectWithoutProperties(_ref3, ["icon", "textTop", "textBottom", "href"]);

  return React.createElement(
    AppWrapper,
    _extends({ className: "app-wrapper", href: href }, restProps),
    React.createElement(
      Icon,
      null,
      icon
    ),
    React.createElement(
      "span",
      null,
      React.createElement(
        Typography,
        {
          size: 0.75,
          style: { lineHeight: "0.875rem" },
          color: "inherit"
        },
        textTop
      ),
      React.createElement(
        Typography,
        {
          size: 0.875,
          bold: true,
          style: { lineHeight: "0.875rem" },
          color: "inherit"
        },
        textBottom
      )
    )
  );
};

export { AppBox };
export var BottomContainer = styled(Grid).withConfig({
  displayName: "atoms__BottomContainer",
  componentId: "sc-1i2egv4-5"
})(["div{margin-bottom:1rem;&:last-of-type{margin-bottom:0;}", "}"], media.desktop(_templateObject));